import React, { useEffect, useContext } from "react"
import { Context } from "../../context/MainContext"

const LocationMap = () => {
  const {
    store: { isMobile },
  } = useContext(Context)

  const styles = {
    paddingTop: `10em`,
    height: `100vh`,
    margin: `0 ${isMobile ? 16 : 40}px`,
  }

  useEffect(() => {
    const script = document.createElement("script")

    script.src = "https://embed.prolofinder.com/js/prolo.js?collection=99927928"
    script.async = true

    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [])
  return <div style={styles} id="ProloFinder"></div>
}

export default LocationMap
